import React from 'react';
import PropTypes from 'prop-types';
import CwFilterList from '../cwfilterlist/CwFilterList';
import CwButton from '../cwbutton/CwButton';
import css from './CwDoubleFilterList.scss';

class CwDoubleFilterList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedAItems: [],
      selectedBItems: [],
    };
  }

  getSelectedByName = (arr, values) => {
    var results = [];

    if (typeof arr == 'undefined') {
      return results;
    }

    for (let i = 0, l = values.length; i < l; i++) {
      for (let j = 0, s = arr.length; j < s; j++) {
        if (values[i] === arr[j].name) {
          results.push(arr[j].id);
          break;
        }
      }
    }

    return results;
  }

  getSelectedById = (arr, values) => {
    var results = [];

    if (typeof arr == 'undefined') {
      return results;
    }

    for (let i = 0, l = values.length; i < l; i++) {
      for (let j = 0, s = arr.length; j < s; j++) {
        if (values[i] === arr[j].id) {
          results.push(arr[j]);
          break;
        }
      }
    }

    return results.sort((a,b) => a.name.localeCompare(b.name));
  }

  getNonSelectedById = (arr, values) => {
    let selected = this.getSelectedById(arr, values);
    let unselected = [];

    if (typeof arr == 'undefined') {
      return unselected;
    }

    unselected = unselected.concat(arr);
    for (let i = 0, l = selected.length; i < l; i++) {
      var index = unselected.indexOf(selected[i]);
      unselected.splice(index, 1);
    }
    
    return unselected.sort((a,b) => a.name.localeCompare(b.name));
  }

  getIdsFromObjects = (arr) => {
    let result = [];

    for (let i = 0, l = arr.length; i < l; i++) {
      result.push(arr[i].id);
    }

    return result;
  }

  componentDidMount() {
    // NOTE: Perform any magic you need when the filterlist re-mounts (i.e. after pod collapses then re-expands)
    if (this.props.onLoad) {
      this.props.onLoad();
    }    
  }

  /**
   * Adds everything in list A to list B
   * The list updates based on what the value is set. So we set the value to
   * all objects and what happens is list A gets an empty array and list B
   * gets an array of all objects
   */
  addAllToSelection = () => {
    let newValue = this.getIdsFromObjects(this.props.items ? this.props.items : []);
    this.props.onChange(newValue);
  };

  /**
   * Add the selected values in list A (left list) to list B (right list)
   * Updates the value so that when the state is updated both list gets a new
   * filtered list
   */
  addSelectedToSelection = () => {
    let previousSelection = this.props.value ? this.props.value : [];
    let selected = this.state.selectedAItems;
    let newValue = [];
    newValue = newValue.concat(previousSelection);
    newValue = newValue.concat(selected);

    this.props.onChange(newValue);
  };

  /**
   * Remove the selected values in list B (right side) and adds it to
   * List A (left side) 
   * Updates the value so that when the state is updated both list gets a new
   * filtered list
   */
  removeSelectedFromSelection = () => {
    let previousSelection = this.props.value ? this.props.value : [];
    let selected = this.state.selectedBItems;
    let newValue = [];
    newValue = newValue.concat(previousSelection);
    for (let i = 0, l = selected.length; i < l; i++) {
      var index = newValue.indexOf(selected[i]);
      newValue.splice(index, 1);
    }

    this.props.onChange(newValue);
  };

  /**
   * Remove everything in list B (right side) and adds it to 
   * List A (left side)
   * Setting the value to an empty [] will filter it so everything
   * is displayed in List A
   */
  removeAllFromSelection = () => {
    let newValue = [];
    this.props.onChange(newValue);
  };

  /**
   * Updated the state with the selected options in list B (right side)
   */
  handleListBChange = (event) => {
    let selection = event ? event : [];
    let intArray = [];
    for (let i = 0, l = selection.length; i < l; i++) {
      intArray.push(parseInt(selection[i], 10));
    }
    this.setState({selectedBItems:intArray});
    if (this.props.onRightSelected) {
      this.props.onRightSelected(event);
    }
  };

  /**
   * handler for when the right-hand-side list loses focus
   */
  handleListBBlur = () => {
    if(this.props.onRightBlur){
      this.props.onRightBlur();
    }
  }
  /**
   * handler for when the right-hand-side receives focus
   */
  handleListBFocus = () => {
    if(this.props.onRightFocus){
      this.props.onRightFocus();
    }
  }

  /**
   * Update the state with the selected options in list A (left side)
   */
  handleListAChange = (event) => {
    let selection = event ? event : [];
    let intArray = [];
    for (let i = 0, l = selection.length; i < l; i++) {
      intArray.push(parseInt(selection[i], 10));
    }

    this.setState({selectedAItems:intArray});
    if (this.props.onLeftSelected) {
      this.props.onLeftSelected(event);
    }
  };

  render() {
    let filter = this.props.value ? this.props.value : [];
    let {items, includeFilter, disabled, leftListLabel, rightListLabel, leftFilter, rightFilter, mapKey, size, placeholder} = this.props;
    let selectedAItems = this.state.selectedAItems ? this.state.selectedAItems : [];
    let selectedBItems = this.state.selectedBItems ? this.state.selectedBItems : [];

    return (
      <div data-cwid={this.props.cwId} className={css.wrap}>
        <div>
          <CwFilterList
            options={filter.length > 0 ? this.getNonSelectedById(items, filter) : items}
            value={selectedAItems}
            onChange={this.handleListAChange}
            cwId={'flistA' + this.props.cwId}
            listHeader={leftListLabel}
            placeholder={placeholder}
            size={size}
            defaultFilter={leftFilter}
            includeFilter={includeFilter}
            mapKey={mapKey}
            disabled={disabled}
            allowMultiSelect={this.props.leftAllowMultiSelect}
          />
        </div>
        <div className={css.buttons}>
          <CwButton
            value={">>"}
            onClick={this.addAllToSelection}
            disabled={disabled}
          />
          <CwButton
            value={">"}
            onClick={this.addSelectedToSelection}
            disabled={disabled}
          />
          <CwButton
            value={"<"}
            onClick={this.removeSelectedFromSelection}
            disabled={disabled}
          />
          <CwButton
            value={"<<"}
            onClick={this.removeAllFromSelection}
            disabled={disabled}
          />
        </div>
        <div>
          <CwFilterList 
            options={filter.length > 0 ? this.getSelectedById(items, filter) : []}
            value={selectedBItems}
            onChange={this.handleListBChange}
            onBlur={this.handleListBBlur}
            onFocus={this.handleListBFocus}
            cwId={'flistB' + this.props.cwId}
            listHeader={rightListLabel}
            placeholder={placeholder}
            size={size}
            defaultFilter={rightFilter}
            includeFilter={includeFilter}
            mapKey={mapKey}
            disabled={disabled}
            allowMultiSelect={this.props.rightAllowMultiSelect}
          />
        </div>
      </div>
    );
  }
}

CwDoubleFilterList.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Callback function that is fired when combobox's selection changes
   */
  onChange: PropTypes.func,
  /**
   * List of all items unfiltered. Must contain at least "id" and "name" fields.
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ),
  /**
   * Path in screenData where the List's value will be stored and retrieved
   */
  value: PropTypes.arrayOf(PropTypes.number),
  /**
   * Label for the left list box
   */
  leftListLabel: PropTypes.string,
  /**
   * Label for the right list box
   */
  rightListLabel: PropTypes.string,
  /**
   * Default filter for left list
   */
  leftFilter: PropTypes.string,
  /**
   * Default filter for right list
   */
  rightFilter: PropTypes.string,
  /**
   * Boolean to render the filter or not
   */
  includeFilter: PropTypes.bool,
  /**
   * Key for the filter map lookup used to filter the list by property
   */
  mapKey: PropTypes.string,
  /**
   * Used to disable the entire widget (lists, filters and buttons)
   */
  disabled: PropTypes.bool,
  /**
   * Callback function that is fired when selection in the left filter list changes
   */
  onLeftSelected: PropTypes.func,
  /**
   * Callback function that is fired when selection in the right filter list changes
   */
  onRightSelected: PropTypes.func,
  /**
   * Allows the user to select multiple items at the same time in the left flist
   */
  leftAllowMultiSelect: PropTypes.bool,
  /**
   * Allows the user to select multiple items at the same time in the right list
   */
  rightAllowMultiSelect: PropTypes.bool, 
  /**
   * handler for when the right-hand-side list loses focus
   */
  onRightBlur: PropTypes.func,
  /**
   * handler for when the right-hand-side list receives focus
   */
  onRightFocus: PropTypes.func
};

CwDoubleFilterList.defaultProps = {
  leftListLabel: 'List A',
  rightListLabel: 'List B',
  leftAllowMultiSelect: true,
  rightAllowMultiSelect: true
};

export default CwDoubleFilterList;


// WEBPACK FOOTER //
// ./src/components/cwdoublefilterlist/CwDoubleFilterList.jsx